import type { RouteComponent } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/login', // Redirige la ruta raíz a '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: async () => import('@/pages/website/LoginPage.vue') as Promise<RouteComponent>,
  },
  {
    path: '/olvide-contrasena',
    name: 'forget-password',
    component: async () => import('@/pages/website/ForgetPassword.vue') as Promise<RouteComponent>,
  },
  // Consumo y plan viven en el panel (Mi cuenta). Sin sesión, cualquier enlace antiguo
  // termina en el login.
  { path: '/consumo/:rest(.*)*', redirect: '/login' },
  {
    path: '/compra-exitosa',
    name: 'purchase-success',
    component: async () => import('@/pages/website/PurchaseSuccessPage.vue') as Promise<RouteComponent>,
    meta: { fullBleed: true },
  },
  {
    path: '/compra-fallida',
    name: 'purchase-failure',
    component: async () => import('@/pages/website/PurchaseFailurePage.vue') as Promise<RouteComponent>,
    meta: { fullBleed: true },
  },
  { path: '/cuentas/:companyId', redirect: '/login' },
  {
    path: '/registro',
    name: 'signup',
    component: async () => import('@/pages/website/SignupPage.vue') as Promise<RouteComponent>,
  },
  {
    path: '/reenviar-email',
    name: 'resend-email',
    component: async () => import('@/pages/website/ResendEmail.vue') as Promise<RouteComponent>,
  },
  {
    path: '/cambiar-contrasena',
    name: 'change-password',
    component: async () => import('@/pages/website/ResetPassword.vue') as Promise<RouteComponent>,
  },
  {
    path: '/clave-unica/:token',
    name: 'ClaveUnica',
    component: async () => import('@/pages/panel/ClaveUnica/Index.vue') as Promise<RouteComponent>,
    props: true,
  },
  {
    path: '/conexion-externa/:token',
    name: 'ExternalConnection',
    component: async () => import('@/pages/website/ExternalConnection.vue') as Promise<RouteComponent>,
    props: true,
  },
  {
    path: '/onboarding/proveedores/:token',
    name: 'PublicVendorOnboarding',
    component: async () => import('@/pages/website/PublicVendorOnboarding.vue') as Promise<RouteComponent>,
    props: true,
  },
  {
    path: '/onboarding/clientes/:token',
    name: 'PublicClientOnboarding',
    component: async () => import('@/pages/website/PublicClientOnboarding.vue') as Promise<RouteComponent>,
    props: true,
  },
]

export default routes
